// import React from "react";
// import Button from "../Button";
// import style from "./style.module.css";
// // import { color } from "highcharts";

// export default function ConfirmationButton({
//   confirmText,
//   rejectText,
//   confirmFunction,
//   rejectFunction,
//   extraConfirmStyle = "",
//   extraRejectStyle = "",
// }) {
//   console.log("gggg==", confirmText, rejectText);
//   return (
//     <div className={`${style.container}`}>
//       {confirmText && (
//         <Button
//           onClick={confirmFunction}
//           className={`${style.secondBtn}  ${extraConfirmStyle}`}
//           // text={confirmText}
//         >
//           {confirmText}
//         </Button>
//       )}
//       {rejectText && (
//         <Button
//           classChildern={style.reject__button}
//           onClick={rejectFunction}
//           className={`${extraRejectStyle} ${style.sendBtn} secondButton`}
//           // text={rejectText}
//         >
//           {rejectText}
//         </Button>
//       )}
//     </div>
//   );
// }

import React, { MouseEvent, ReactNode } from 'react';
import Button from '../Button';
import style from './style.module.css';

interface ConfirmationButtonProps {
  confirmText?: string | ReactNode;
  rejectText?: string | ReactNode;
  confirmFunction?: (event: MouseEvent<HTMLButtonElement>) => void;
  rejectFunction?: (event: MouseEvent<HTMLButtonElement>) => void;
  extraConfirmStyle?: string;
  extraRejectStyle?: string;
  className?: string;
  rejectType?: string;
  confirmType?: string;
  confirmHref?: string;
  rejectHref?: string;
  buttonsClass?: string;
  confirmDisabled?: boolean;
  rejectDisabled?: boolean;
}

export default function ConfirmationButton({
  confirmText,
  rejectText,
  confirmFunction,
  rejectFunction,
  extraConfirmStyle = '',
  extraRejectStyle = '',
  className = '',
  rejectType = 'button',
  confirmType = 'button',
  confirmHref,
  rejectHref,
  buttonsClass = '',
  confirmDisabled = false,
  rejectDisabled = false,
}: ConfirmationButtonProps): JSX.Element {
  console.log('gggg==', confirmText, rejectText);

  return (
    <div className={`${style.container} ${className}`}>
      {confirmText && (
        <Button
          onClick={confirmFunction}
          className={`btn btn-white ${style.button} ${buttonsClass} ${extraConfirmStyle}`}
          // text={confirmText}
          type={confirmType}
          href={confirmHref}
          disabled={confirmDisabled}
        >
          {confirmText}
        </Button>
      )}
      {rejectText && (
        <Button
          onClick={rejectFunction}
          className={`${extraRejectStyle} btn btn-primary ${style.button} ${buttonsClass}  ${style.reject__button}`}
          type={rejectType}
          href={rejectHref}
          // text={rejectText}
          disabled={rejectDisabled}
        >
          {rejectText}
        </Button>
      )}
    </div>
  );
}
